module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-200italic.woff?db53fe94622d2fbbf2fc6a22411cbd7e";